import { useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/Tooltip";

/**
 * Libellé de sidebar tronqué (`truncate`) qui affiche le nom complet
 * dans un tooltip — uniquement quand le texte déborde réellement.
 * Utile pour les entrées dynamiques longues (« Réservations <collection> »).
 *
 * La troncature est mesurée AU SURVOL (tooltip contrôlé) plutôt qu'au
 * montage : à ce moment le layout est garanti stable, alors qu'une
 * mesure au mount/effect peut tomber pendant l'animation d'ouverture de
 * l'accordéon (largeur pas encore définitive → `scrollWidth ===
 * clientWidth` → détection ratée).
 */
export const TruncatedSidebarLabel = ({ text }: { text: string }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    if (!next) {
      setOpen(false);
      return;
    }
    const el = ref.current;
    setOpen(!!el && el.scrollWidth > el.clientWidth);
  };

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip open={open} onOpenChange={handleOpenChange}>
        <TooltipTrigger asChild>
          <span ref={ref} className="block truncate min-w-0">
            {text}
          </span>
        </TooltipTrigger>
        <TooltipContent side="right">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
